// Rotating status labels used by the assistant loader while waiting for a response.
// Why: long-running requests feel more responsive when the UI communicates progress.
export const nurseSpinnerLabels: string[] = [
	'Admitting',
	'Assessing',
	'Attending',
	'Bagging',
	'Bandaging',
	'Bedside-rounding',
	'Boosting',
	'Boosting-spirits',
	'Calibrating',
	'Calming',
	'Caring',
	'Catching-details',
	'Championing',
	'Charging-up',
	'Charting',
	'Checking-in',
	'Checking-vitals',
	'Cheerleading',
	'Clarifying',
	'Coaching',
	'Collaborating',
	'Collecting',
	'Comforting',
	'Connecting-dots',
	'Coordinating',
	'Counting-drops',
	'Cross-checking',
	'Cueing',
	'Debriefing',
	'Decoding',
	'De-escalating',
	'Delivering-care',
	'Disinfecting',
	'Documenting',
	'Dosing',
	'Double-checking',
	'Educating',
	'Encouraging',
	'Escalating',
	'Escorting',
	'Examining',
	'Fetching',
	'Fine-tuning',
	'Flow-managing',
	'Focus-finding',
	'Following-up',
	'Gowning-up',
	'Guiding',
	'Hand-holding',
	'Handing-off',
	'Harmonizing',
	'Head-to-toeing',
	'Healing',
	'Helping-heal',
	'Huddling',
	'Hydrating',
	'Imaging',
	'Immunizing',
	'Infusing',
	'Intaking',
	'Interpreting',
	'Investigating',
	'Jumping-in',
	'Keeping-watch',
	'Kicking-into-care',
	'Labeling',
	'Lab-chasing',
	'Leaning-in',
	'Listening',
	'Logging',
	'Looping-in',
	'Making-rounds',
	'Mapping',
	'Marshaling',
	'Measuring',
	'Med-checking',
	'Med-passing',
	'Mentoring',
	'Monitoring',
	'Motivating',
	'Multitasking',
	'Navigating',
	'Nebulizing',
	'Notifying',
	'Nurturing',
	'Observing',
	'Onboarding',
	'Optimizing',
	'Organizing',
	'Orchestrating',
	'Ordering',
	'Oxygenating',
	'Paging',
	'Palpating',
	'Paperworking',
	'Partnering',
	'Patient-prepping',
	'Pep-talking',
	'Peacemaking',
	'Perking-up',
	'Phone-tagging',
	'Pivoting',
	'Plan-making',
	'Plotting-care',
	'Positioning',
	'Prepping',
	'Pressure-checking',
	'Prioritizing',
	'Problem-solving',
	'Processing',
	'Protecting',
	'Pulse-ox-checking',
	'Rallying',
	'Reading-the-room',
	'Reassuring',
	'Rechecking',
	'Recovering',
	'Recording',
	'Reconciling',
	'Redirecting',
	'Refreshing',
	'Registering',
	'Repositioning',
	'Reporting',
	'Responding',
	'Restocking',
	'Reviewing',
	'Rhythm-checking',
	'Rounding',
	'Routing',
	'Running-labs',
	'Safety-netting',
	'Sanitizing',
	'Scanning',
	'Scheduling',
	'Screening',
	'Scrubbing',
	'Securing',
	'Sense-making',
	'Settling',
	'Shift-covering',
	'Skin-checking',
	'Sleuthing',
	'Smiling',
	'Smoothing-the-day',
	'Soothing',
	'Specimen-labeling',
	'Speed-walking',
	'Spotting-changes',
	'Stabilizing',
	'Stat-charting',
	'Step-counting',
	'Sterilizing',
	'Stethoscoping',
	'Story-gathering',
	'Supporting',
	'Swabbing',
	'Syncing',
	'Teaching',
	'Teaming-up',
	'Team-high-fiving',
	'Temperature-taking',
	'Testing',
	'Therapy-coordinating',
	'Tracking',
	'Transcribing',
	'Trend-watching',
	'Triaging',
	'Troubleshooting',
	'Tubing-taming',
	'Updating',
	'Validating',
	'Verifying',
	'Vitals-checking',
	'Watching-closely',
	'Welcoming',
	'Whisper-coaching',
	'Wrangling',
	'Wonder-working',
	'Wristband-checking',
	'Chart-chasing',
	'Bed-making',
	'Call-light-answering',
	'Care-coordinating',
];

// Returns `count` unique random indexes in [0, max).
// Why: MatrixLoader needs a fresh random subset of cells to animate each tick.
export function pickUnique(count: number, max: number): Set<number> {
	const set = new Set<number>();
	const target = Math.min(count, max);
	while (set.size < target) {
		set.add(Math.floor(Math.random() * max));
	}
	return set;
}

export function formatQueryTime(elapsedMs: number): string {
	const totalSeconds = Math.floor(elapsedMs / 1000);
	const minutes = Math.floor(totalSeconds / 60);
	const seconds = totalSeconds % 60;
	return `${minutes}m ${seconds}s`;
}

export function setFavicon(href: string): void {
	if (typeof document === 'undefined') return;
	let favicon = document.querySelector("link[rel='icon']") as HTMLLinkElement | null;
	if (!favicon) {
		favicon = document.createElement('link');
		favicon.rel = 'icon';
		document.head.appendChild(favicon);
	}
	favicon.href = href;
}

export function createDotFaviconDataUri(hexColor: string): string {
	const dotSvg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'><circle cx='32' cy='32' r='22' fill='${hexColor}'/></svg>`;
	return `data:image/svg+xml,${encodeURIComponent(dotSvg)}`;
}

export function formatFileSize(bytes: number): string {
	if (bytes === 0) return '0 Bytes';
	const k = 1024;
	const sizes = ['Bytes', 'KB', 'MB', 'GB'];
	const i = Math.floor(Math.log(bytes) / Math.log(k));
	return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
}
